import { render, staticRenderFns } from "./sync-screen-shimmer.vue?vue&type=template&id=2e61245a&scoped=true"
import script from "./sync-screen-shimmer.vue?vue&type=script&lang=js"
export * from "./sync-screen-shimmer.vue?vue&type=script&lang=js"
import style0 from "./sync-screen-shimmer.vue?vue&type=style&index=0&id=2e61245a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e61245a",
  null
  
)

export default component.exports